import React from 'react';
import Button from '../ui/Button';
import Icon from '../AppIcon';
import { useAuth } from '../../context/AuthContext';

const GuestSignOutDialog = () => {
   const { isGuestSignOutDialogOpen:isOpen, closeGuestSignOutDialog:onClose, signOutUser:onConfirm } = useAuth();
  const { openAuthModal } = useAuth();

  if (!isOpen) {
    return null;
  }

  const handleMakePermanent = () => {
    openAuthModal('signUp');
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black/60 z-[999] flex items-center justify-center p-4">
      <div className="bg-card rounded-lg shadow-2xl w-full max-w-sm p-6 animate-scale-in relative">
        <button
          className="absolute top-4 right-4 text-muted-foreground hover:text-foreground cursor-pointer"
          onClick={onClose}
        >
          <Icon name="X" size={16} />
        </button>
        <div className="text-center">
          <Icon name="AlertTriangle" size={48} className="text-yellow-500 mx-auto mb-4" />
          <h2 className="text-xl font-bold text-foreground mb-2">Are you sure?</h2>
          <p className="text-muted-foreground mb-6">
            You are currently signed in as a guest. If you log out, your My Orders will be lost. To save your orders, you can create a permanent account.
          </p>
        </div>
        <div className="space-y-3">
          <Button onClick={handleMakePermanent} fullWidth variant="outline">
            <Icon name="UserPlus" className="mr-2" />
            Make it Permanent
          </Button>
          <Button onClick={onConfirm} fullWidth variant="destructive">
            <Icon name="LogOut" className="mr-2" />
            Logout Anyway
          </Button>
          <Button onClick={onClose} fullWidth variant="ghost">
            Cancel
          </Button>
        </div>
      </div>
    </div>
  );
};

export default GuestSignOutDialog;
